import { useQuery } from "@tanstack/react-query";
import { AXIOS_RESERVATION } from "../utils/axios-interceptors";

const useGetLightSceneModeQuery = (data?: any): any =>
  useQuery({
    queryKey: ["light-scene-list"],
    queryFn: async () => {
      const response = await AXIOS_RESERVATION.get("/getLightSceneModeList", {params: data});
      return response.data;
    },
  });

export default useGetLightSceneModeQuery;
